import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatError, MatFormField } from '@angular/material/form-field'
import {
  ElderBasicPaneLayoutComponent,
  ElderDimensionsInputComponent,
  ElderPaneComponent,
  ElderPaneSubtitleComponent,
  ElderPlugParentFormDirective,
  ElderValidationErrorDirective,
  LocalListDataSource,
} from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { PackageType, PackagingMaterialSpec } from '../../package-type'
import { PackageTypeDetailController } from '../package-type-detail-controller.service'
import { PackageTypeMaterialTableComponent } from '../packaging-material/package-type-material-table/package-type-material-table.component'

@Component({
  selector: 'app-package-type-presets',
  imports: [
    AsyncPipe,
    ElderBasicPaneLayoutComponent,
    ElderDimensionsInputComponent,
    ElderPaneComponent,
    ElderPaneSubtitleComponent,
    ElderValidationErrorDirective,
    MatError,
    MatFormField,
    ElderTranslatePipe,
    FormsModule,
    ElderPlugParentFormDirective,
    PackageTypeMaterialTableComponent,
  ],
  templateUrl: './package-type-presets.component.html',
  styleUrl: './package-type-presets.component.scss',
})
export class PackageTypePresetsComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly controller = inject(PackageTypeDetailController)

  public readonly supportedPackagingMaterialsDs$: Observable<
    LocalListDataSource<PackagingMaterialSpec>
  >

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.supportedPackagingMaterialsDs$ = this.controller.packageType$.pipe(
      map((packageType) =>
        LocalListDataSource.from(packageType.supportedPackagingMaterials, 'materialId')
      )
    )
  }

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  public get packageType$(): Observable<PackageType> {
    return this.controller.packageType$
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/
}
